import { Box } from '@mui/material'
import React, { useState } from 'react'
import NotificationItem from './NotificationItem'
import NotificationPagination from './NotificationPagination'
import { NotificationModel } from '../../models/notifications.model'

interface Props {
  notifications: NotificationModel[]
  onMarkNotificationsAsRead: (id: number) => void
}

/**
 * Displays one notification item which can be switched based on a paginator.
 */
const NotificationModalContent: React.VFC<Props> = ({ notifications, onMarkNotificationsAsRead }) => {
  const [currentNotificationIndex, setCurrentNotificationIndex] = useState(0)
  const currentMandatoryNotification = notifications[currentNotificationIndex]

  return (
    <Box>
      <NotificationItem
        id={currentMandatoryNotification?.id}
        text={currentMandatoryNotification?.text}
        startAt={currentMandatoryNotification.startAt}
        title={currentMandatoryNotification?.title}
        sxStyle={{ marginTop: 4 }}
        onMarkNotificationsAsRead={onMarkNotificationsAsRead}
      />
      <NotificationPagination
        currentPage={currentNotificationIndex + 1}
        lastPage={notifications.length}
        setPage={setCurrentNotificationIndex}
        sxStyle={{ marginTop: 1 }}
      />
    </Box>
  )
}

export default NotificationModalContent
